import { InjectionToken } from "@angular/core";
/**
 * @type {symbol} Angular Dependency Injection provider token a LoadingMaskConfig számára.
 */
export const LoadingMaskConfigToken: InjectionToken<LoadingMaskConfig> = new InjectionToken<LoadingMaskConfig>("loading-mask.config.model");
/**
 * Loading maszk konfigurációs model-je.
 */
export interface LoadingMaskConfig {
    /**
     * URL lista, ahol nem szeretnénk, hogy a központi loading maszk megjelenjen
     */
    urlBlackList: string[];
}
